import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const [synchronized, setSynchronized] = useState(true);
  const [current, setCurrent] = useState(0);

  useEffect(() => {

    axios.request("/common/time",{
      method:"GET",
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(async (res)=>{

      setCurrent(new Date(res.data.time).toLocaleString());

      if(Math.abs(res.data.time - new Date().getTime()) < 2 * 60 * 1000 ){
        setSynchronized(true);
      }else{
        setSynchronized(false);
      }

    })

    return ()=>{ }

  }, []);

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  const winDownload         = "https://glados.rocks/tools/Clash.for.Windows.Setup.exe";
  const clashDownload       = "https://glados.rocks/tools/clash_for_android.apk";
  const macDownload         = "https://glados.rocks/tools/ClashX.dmg";

  var subscribe_endpoint = "update.glados-config.com";
  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";

  const sub    = 'sub://' + Base64.encode(`https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`) + "#Github.com/GLaDOS-network";
  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const ipv6             = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-ipv6.yaml`
  const padavan_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-padavan.yaml`
  const koolshare_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/koolshare.yaml`
  const openclash_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-openclash.yaml`
  const [url,setURL] = useState(false);

  if(url){
    return <Redirect to={url}/>
  }

  const not_supported = <Fragment>
        <Segment placeholder>
          <Header icon>
            <Icon name='cloud upload' />
            <p>路由器配置仅为 Pro/Team/Enterprise 用户提供</p>
          </Header>
          <Link to="/console/shop">
            <Button primary>升级</Button>
          </Link>
        </Segment>
  </Fragment>

  const [clipboard,setClipboard] = useState(false);
  const base = 30;

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.router.title")}
      <Header.Subheader>
      {t("settings.router.notes")}
      </Header.Subheader>
    </Header>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
             Devices
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>

              <Tab menu={{ color:"blue", secondary: true}} panes={[
                {
                  menuItem:<Menu.Item key='pro33'>R2S/R4S/Raspberry Pi/x86</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

                      {user_vip>base?
                      <Fragment>
                        <p>1. 将 OpenWrt-Rpi 固件刷入路由器(<a href="https://github.com/SuLingGG/OpenWrt-Rpi">下载固件</a>)</p>
                        <p>2. 启动路由器，进入 http://192.168.1.1, 登录管理界面 (用户名:root / 密码:password)</p>
                        <p>3. 选择服务-OpenClash-配置文件订阅</p>
                        <p>4. 添加专用配置:<Label>{openclash_suburl}</Label>，点击应用配置</p>
                        <b>5. 选择全局设置-模式设置-取消UDP流量转发, 点击应用配置 </b>
                        <p>6. 在运行状态里点击启动 OPENCLASH </p>

                      </Fragment>
                          :not_supported }

                        </Tab.Pane>)
                  }
                },
                {
                  menuItem:<Menu.Item key='pro33'>OpenWRT</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

                      {user_vip>base?
                      <Fragment>
                        <p>OpenWRT 上安装 OpenClash 作为主路由使用</p>

                        <p>1. 安装支持 openClash 插件的 openWRT 到路由器(或在 <a href="https://github.com/vernesong/OpenClash/wiki/%E5%AE%89%E8%A3%85">OpenWRT 上安装 OpenClash</a>)</p>
                        <p>2. 复制专用配置文件地址:<Label>{openclash_suburl}</Label></p>
                        <p>3. 在 openClash 里添加配置文件 <a href="https://www.notion.so/openclash-guide-88ccf0d76240431d98e9de0cf04739c9">教程</a></p>

                      </Fragment>
                          :not_supported }

                        </Tab.Pane>)
                  }
                },
                /*{
                  menuItem:<Menu.Item key='pro33'>Koolshare/LEDE</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

                      {user_vip>base?
                      <Fragment>
                        <p>如果你有刷入 Koolshare 固件(https://firmware.koolshare.cn)的X86架构的路由器，路由器可以作为<b>旁路路由</b>接入GLaDOS.</p>
                        <p>不能作为主路由使用, 请了解主路由以及旁路路由的区别.</p>

                        <p>1. 安装 Koolshare 路由器，并作为旁路路由加入主路由的Lan 接口, 设置他的IP为固定，如192.168.1.32</p>
                        <p>2. 在Koolshare上离线安装 <a href="https://github.com/SukkaW/Koolshare-Clash/releases">Clash for Koolshare</a></p>
                        <p>3. 使用配置文件:<Label>{koolshare_suburl}</Label></p>
                        <p>4. 启动路由器 Clash</p>
                        <p>5. 设置其他设备的网关(gateway)为旁路路由的IP(如192.168.1.32), DNS设置为198.19.0.1</p>
                        <p><a href="https://koolclash.js.org">Koolshare 详细说明</a></p>
                        <p>配置文件不能用于 Clash 其他客户端，仅用于 Koolshare 路由器。</p>
                      </Fragment>
                          :not_supported }

                        </Tab.Pane>)
                  }
                },
                {
                  menuItem:<Menu.Item key='pro33'>Padavan</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                      {user_vip>base?
                      <Fragment>
                        <p>推荐更新到2020年03月01日以后的固件版本</p>
                        <p>选择扩展功能-搭建Web环境, 找到 clash 面板, 选中开启 clash, 打开透明代理</p>
                        <p>填写配置文件: <Label>{padavan_suburl}</Label>, 开启自动更新</p>
                      </Fragment>
                          :not_supported }
                        </Tab.Pane>)
                  }
                }
  */
              ]} />
        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
